import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const AdminPayments = () => {
  const [payments, setPayments] = useState(null);

  useEffect(() => {
    api.get("/admin/payments").then((r) => setPayments(r.data.payments)).catch(() => setPayments([]));
  }, []);

  let body;
  if (payments === null) {
    body = <Loader2 className="w-6 h-6 text-brand animate-spin" />;
  } else if (payments.length === 0) {
    body = <p data-testid="admin-payments-empty" className="text-sm text-zinc-600">No payments yet.</p>;
  } else {
    body = (
      <ul className="divide-y divide-zinc-100">
          {payments.map((p) => (
            <li key={p.id} data-testid={`admin-payment-${p.id}`} className="py-3 first:pt-0 last:pb-0">
              <div className="flex flex-wrap justify-between gap-2">
                <p className="font-medium text-brand-ink">{p.item_id} <span className="text-brand font-bold">${p.amount}</span></p>
                <span className="text-xs text-zinc-500">{p.created_at?.slice(0, 10)}</span>
              </div>
              <p className="text-sm text-zinc-600 mt-0.5">{p.payer_name || "Customer"} · {p.payer_email} · {p.status}</p>
            </li>
          ))}
        </ul>
    );
  }

  return (
    <div data-testid="admin-payments-card" className="bg-white border border-zinc-200 p-6 rounded-sm mt-6">
      <h2 className="font-heading font-bold text-lg text-brand-ink mb-4">Recent Payments (Admin)</h2>
      {body}
    </div>
  );
};
